import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IMortgagePossibleTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const MortgagePossibleTagItem = ({ onDeleteClick, withNewTag }: IMortgagePossibleTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Возможна ипотека
    </TagComponent>
  );
};
